import { generateRoute } from '@klpkonsern/routing';

export const UserModuleName = 'user';

export const brukerApiName = 'bruker';
export const userApiName = 'user';
export const usersApiName = 'users';
export const regionApiName = 'region';
export const rollerApiName = 'rolle';
export const byggProsjektkontrollerApiName = 'byggprosjektkontroller';

export const UserRoutes = {
    moduleRoute: () => generateRoute([UserModuleName]),
    single: (id: string) => generateRoute([UserModuleName, id]),
};
